import { render, staticRenderFns } from "./contract-review-nl.vue?vue&type=template&id=2501f81a&scoped=true"
import script from "./contract-review-nl.vue?vue&type=script&lang=js"
export * from "./contract-review-nl.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=2501f81a&prod&scoped=true&lang=css&external"
import style1 from "./contract-review-nl.vue?vue&type=style&index=1&id=2501f81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2501f81a",
  null
  
)

export default component.exports